import React from "react";
import "./DetailVideo.css";
import ReactPlayer from "react-player";
import { Link, useParams } from "react-router-dom";
import Bola from "../Bola";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";
import axios from "axios";
import Comment from "../Comment/Comment";
import { baseURL } from "../Config/Config";

export default function DetailVideo() {
  const [post, setPost] = React.useState();
  let { id } = useParams();

  React.useEffect(() => {
    axios.get(`${baseURL}video/video-material-list/${id}/`).then((response) => {
      setPost(response.data);
    });
  }, []);
  if (!post) return null;

  return (
    <div>
      <Navbar />
      <Bola />
      <div className="container">
        <div className="video-top">
          <div className="left">
            <Link to="/" className="bosh">
              Bosh sahifa
            </Link>

            <Link to="/detail" className="left-material">
              Video kurslar
            </Link>
          </div>
        </div>

        <div>
          <div className="detail">
            <div className="detail-video">
              <ReactPlayer className="detail-player" controls={true} url={post.video_link} />
            </div>
            <h4 className="detail-box-title">{post.title}</h4>
          </div>
          <div className="detail-text">
            {/* <h4>Course Details</h4> */}
            <p>{post.sub_content}</p>

            {/* {post.comments.map((e, i) => {
              return (
                <div key={i}>
                  {" "}
                  <p>
                    <b> user: </b>
                    {e.content}
                  </p>
                  <br />
                  {e.all_replies.map((element, index) => {
                    return (
                      <div className="replycomment">{element.content}</div>
                    );
                  })}
                </div>
              );
            })} */}
          </div>
          <br />
          <br />
          <br />
          <Comment comments={post.comments} />
        </div>
      </div>
      <Footer />
    </div>
  );
}
